import { Controller } from '@hotwired/stimulus';
import alertify from 'shared/alertify';

export default class extends Controller {
  static targets = ['detail'];

  static values = { url: String };

  // action="order-items-accordion#load"
  // show.bs.collapse は jQuery の trigger で発火し data-action では受け取れないため click を起点にする
  async load() {
    if (this.loaded) return;
    this.loaded = true;

    try {
      const response = await fetch(this.urlValue, {
        headers: { Accept: 'text/html' },
      });
      if (!response.ok) throw new Error(response.statusText);
      this.detailTarget.innerHTML = await response.text();
    } catch (error) {
      this.loaded = false;
      console.error(error);
      alertify.error('エラーが発生しました。時間をおいて再度お試しください。');
    }
  }
}
